// @ts-nocheck
// Greif UI Kit = line-collapse-menu
import React from "react";

const CollapseMenuLine: React.FC = () => {
    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <path
                fill="currentColor"
                d="M16.673 14.818V9.182q0-.391-.345-.538-.345-.145-.624.134l-2.42 2.42q-.342.345-.342.803 0 .46.342.8l2.42 2.42q.28.28.624.135.345-.147.345-.538M5.072 21.203q-.945 0-1.61-.665a2.2 2.2 0 0 1-.665-1.61V5.072q0-.944.665-1.61t1.61-.665h13.856q.945 0 1.61.665t.665 1.61v13.856q0 .944-.665 1.61-.666.665-1.61.665zm2.88-2.275V5.072h-2.88v13.856zm2.275 0h8.701V5.072h-8.7z"
            />
        </svg>
    );
};

export default React.memo(CollapseMenuLine);
